module.exports = __webpack_public_path__ + "img/testimonial-rosemarie-rosa.34d394ec.png";